export default __webpack_public_path__ + "static/media/smpa_logo_rund_sw.0158186e.png";